import { createEntityAdapter } from '@reduxjs/toolkit';

import type { IFAQ } from '@/Module/Question/Model';

export const FAQAdapter = createEntityAdapter<IFAQ>({ selectId: model => model.id });
